import { ModalKey } from "constants/modal";
import UpdateAvatarModal from "./UpdateAvatar";

export const ModalComponent = {
  [ModalKey.UPDATE_AVATAR]: UpdateAvatarModal,
}
